import instance from "./auth";

export const getAllData = async (params) => {
    const {data} = await instance.get("/missions/all", {
        params,
    });
    return data;
}

export const getAll = async (params) => {
    const {data} = await instance.get("/missions", {
        params,
    });
    return data;
}

export const createGetById = (id) => {
    const getById = async (params) => {
        const {data} = await instance.get(`/missions/${id}`, {
            params,
        });
        return data;
    }

    return getById;
}

export const getById = async (id) => {
    const {data} = await instance.get(`/missions/${id}`);
    return data;
}

export const updateById = async (id, data) => {
    const {data: result} = await instance.put(`/missions/${id}`, data);
    return result;
}


